<template>
  <validation-observer
    v-slot="{ invalid }"
    ref="rules"
    tag="div"
  >
    <pop-up
      :disabled="invalid"
      :spinning="updatingProject"
      button-text="Update"
      title="Update Project Name"
      class="top-fade-in"
      @add="onSave"
      @close="$emit('close')"
    >
      <validation-provider
        #default="{ errors }"
        name="Project Name"
        rules="required"
        class="w-100 mb-1"
      >
        <input-field
          name="project_name"
          label="Project Name"
          label-position="top"
          :error="errors.length ? errors[0] : null"
        >
          <b-form-input
            id="project_name"
            v-model="name"
            placeholder="Enter project name here..."
            :state="errors.length > 0 ? false : null"
          />
        </input-field>
      </validation-provider>
    </pop-up>
  </validation-observer>
</template>
<script>
import PopUp from '@/components/popup/Pop-up.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    PopUp,
  },
  data() {
    return {
      required,
      name: '',
    }
  },
  computed: {
    project() {
      return this.$store.getters['projects/selectedProject']
    },
    updatingProject() {
      return this.$store.state.projects.updatingProject
    },
  },
  created() {
    this.name = this.project.name
  },
  methods: {
    onSave() {
      this.$store
        .dispatch('projects/setProject', { name: this.name })
        .then(() => {
          this.$emit('close')
          this.$store.commit('app/SET_PROJECT_NAME', this.name)
          this.successToast('Project name was updated.')
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating project.')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .paper {
    width: 100%;
    @media (min-width: 1200px) {
      width: 75%;
    }
  }
}
</style>
